import React, { useState, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Chip,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import FormatDateHour from "../../../utils/FormatDateHour";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { MascaraValor } from "../../../utils/MascaraValor";
import Loading from "../../components/Loading";
import ReceiptIcon from '@mui/icons-material/Receipt';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const coresStatus = {
    CONCLUIDO: { bg: "#dcfce7", cor: "#15803d" },
    PENDENTE: { bg: "#fef3c7", cor: "#b45309" },
    "Pedido de Cancelamento": { bg: "#fef3c7", cor: "#b45309" },
    CANCELADO: { bg: "#fee2e2", cor: "#b91c1c" },
    REJEITADO: { bg: "#fee2e2", cor: "#b91c1c" },
};

const filtrosStatus = [
    { label: "Todas", valor: "" },
    { label: "Concluídas", valor: "CONCLUIDO" },
    { label: "Pendentes", valor: "PENDENTE" },
    { label: "Canceladas", valor: "CANCELADO" },
    { label: "Rejeitadas", valor: "REJEITADO" },
];

// Mesmo formato tratado por MascaraValor: somente dígitos, com os 2 últimos como centavos
const valorEmReais = (valor) => (parseInt(String(valor ?? "").replace(/\D/g, ""), 10) || 0) / 100;

const moeda = (numero) => numero.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const CardResumo = ({ titulo, valor, icone, destaque }) => (
    <Box sx={{ ...cardSx, p: 2, display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, minHeight: 110 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.8, color: "#374151", textTransform: "uppercase" }}>
                {titulo}
            </Typography>
            <Box
                sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "8px",
                    backgroundColor: destaque ? "#fef3c7" : "#f3f4f6",
                    color: destaque ? "#d97706" : "#374151",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: 18 },
                }}
            >
                {icone}
            </Box>
        </Box>
        <Typography sx={{ fontSize: { xs: 22, md: 24 }, fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>{valor}</Typography>
    </Box>
);

const NotasFiscaisEmitidas = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [busca, setBusca] = useState("");
    const [filtroStatus, setFiltroStatus] = useState("");
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);
    const [openModalEditarServico, setOpenModalEditarServico] = useState(false);
    const [openModalExcluirServico, setOpenModalExcluirServico] = useState(false);
    const [notasFiscais, setNotasFiscais] = useState([])
    const [idServico, setIdServico] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        // Verifica se o usuário está com servico vencida
        const hasservicosVencidas = user?.servicos?.vencidas?.length > 0;

        if (hasservicosVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])

    useEffect(() => {
        const getNotasFiscais = async () => {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarNotasFiscaisEmitidas`, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            console.log(response.data.notasFiscais);
            if (response.data.status === 200) {
                setNotasFiscais(response.data.notasFiscais);
            }
        }

        getNotasFiscais();

    }, [openModalEditarServico, openModalExcluirServico])


    const handleCancelNota = async (idIntegracao) => {
        try {
            setOpen(true);
            await axios.post(`${process.env.REACT_APP_API_URL}/cancelarNotaFiscal`, { idIntegracao }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });
            alert("Nota fiscal cancelada com sucesso.");
        } catch (error) {
            alert("Erro ao cancelar a nota fiscal. Por favor, tente novamente mais tarde.");
            console.error("Erro ao cancelar nota fiscal:", error);
        } finally {
            // Atualiza a lista de notas fiscais após o cancelamento
            setOpen(false);
        }
    }

    const termoBusca = busca.trim().toLowerCase();
    const notasFiltradas = notasFiscais.filter((nota) => {
        if (filtroStatus && nota.status !== filtroStatus) return false;
        if (!termoBusca) return true;
        return [nota.idNota, nota.numeroNota, nota.status, MascaraValor(nota.valor), FormatDateHour(nota.dataEmissao)]
            .some((campo) => String(campo ?? "").toLowerCase().includes(termoBusca));
    });

    const notasConcluidas = notasFiscais.filter((nota) => nota.status === "CONCLUIDO");
    const totalFaturado = notasConcluidas.reduce((soma, nota) => soma + valorEmReais(nota.valor), 0);
    const totalPendentes = notasFiscais.filter((nota) => nota.status === "PENDENTE" || nota.status === "Pedido de Cancelamento").length;
    const totalCanceladas = notasFiscais.filter((nota) => nota.status === "CANCELADO" || nota.status === "REJEITADO").length;

    const cabecalhoSx = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase", borderBottom: "none", py: 1 };
    const celulaSx = { fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6", py: 1.25 };

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <ReceiptIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Notas Fiscais Emitidas
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Notas Fiscais Emitidas
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Acompanhe o status das suas NFS-e, baixe os PDFs e solicite cancelamentos.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<AddCircleOutlineIcon />}
                            onClick={() => navigate("../Dashboard/EmitirNotaServico")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", backgroundColor: "#ffc845", borderRadius: "8px", boxShadow: "none", px: 2, "&:hover": { backgroundColor: "#f5b82e", boxShadow: "none" } }}
                        >
                            Emitir NFS-e
                        </Button>
                    </Box>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(4, 1fr)" },
                        gap: 2,
                    }}
                >
                    <CardResumo titulo="Notas emitidas" valor={notasFiscais.length} icone={<ReceiptLongOutlinedIcon />} />
                    <CardResumo titulo="Total faturado" valor={moeda(totalFaturado)} icone={<LocalAtmOutlinedIcon />} />
                    <CardResumo titulo="Em processamento" valor={totalPendentes} icone={<HourglassEmptyOutlinedIcon />} destaque={totalPendentes > 0} />
                    <CardResumo titulo="Canceladas / rejeitadas" valor={totalCanceladas} icone={<BlockOutlinedIcon />} />
                </Box>

                <Box sx={{ ...cardSx, mt: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", mb: 2 }}>
                        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                            {filtrosStatus.map((filtro) => {
                                const ativo = filtroStatus === filtro.valor;
                                return (
                                    <Chip
                                        key={filtro.label}
                                        label={filtro.label}
                                        onClick={() => setFiltroStatus(filtro.valor)}
                                        sx={{
                                            fontSize: 12,
                                            fontWeight: 600,
                                            height: 30,
                                            borderRadius: "8px",
                                            backgroundColor: ativo ? "#0b243d" : "#f3f4f6",
                                            color: ativo ? "#fff" : "#374151",
                                            "&:hover": { backgroundColor: ativo ? "#0b243d" : "#e5e7eb" },
                                        }}
                                    />
                                );
                            })}
                        </Box>
                        <TextField
                            placeholder="Buscar por número, valor, data..."
                            size="small"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{ width: { xs: "100%", sm: 300 }, "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff", fontSize: 13 } }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search sx={{ fontSize: 18, color: "#6b7280" }} />
                                        </InputAdornment>
                                    )
                                }
                            }}
                        />
                    </Box>

                    <TableContainer sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 640 }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f3f4f6", "& th:first-of-type": { borderRadius: "6px 0 0 6px" }, "& th:last-of-type": { borderRadius: "0 6px 6px 0" } }}>
                                    <TableCell sx={cabecalhoSx}>Nota</TableCell>
                                    <TableCell sx={cabecalhoSx}>Data de emissão</TableCell>
                                    <TableCell sx={cabecalhoSx} align="right">Valor</TableCell>
                                    <TableCell sx={cabecalhoSx} align="center">Status</TableCell>
                                    <TableCell sx={cabecalhoSx} align="center">Ações</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {notasFiltradas.length > 0 ? (
                                    notasFiltradas.map((nota) => {
                                        const cores = coresStatus[nota.status] || { bg: "#f3f4f6", cor: "#374151" };
                                        const podeCancelar = !(nota.status === 'PENDENTE' || nota.status === 'CANCELADO' || nota.status === 'Pedido de Cancelamento' || nota.status === 'REJEITADO');
                                        return (
                                            <TableRow key={nota.idNota} hover>
                                                <TableCell sx={celulaSx}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                                        <Box sx={{ width: 32, height: 32, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                            <ReceiptLongOutlinedIcon sx={{ fontSize: 18 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>
                                                                {nota.numeroNota ? `NFS-e #${nota.numeroNota}` : "Número pendente"}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>ID {nota.idNota}</Typography>
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                <TableCell sx={celulaSx}>{FormatDateHour(nota.dataEmissao)}</TableCell>
                                                <TableCell sx={{ ...celulaSx, fontWeight: 700, color: "#111827", whiteSpace: "nowrap" }} align="right">
                                                    R$ {MascaraValor(nota.valor)}
                                                </TableCell>
                                                <TableCell sx={celulaSx} align="center">
                                                    <Chip label={nota.status} size="small" sx={{ backgroundColor: cores.bg, color: cores.cor, fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.4 }} />
                                                </TableCell>
                                                <TableCell sx={celulaSx} align="center">
                                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 0.5 }}>
                                                        <Tooltip title="Download PDF">
                                                            <IconButton
                                                                size="small"
                                                                sx={{ color: "#16a34a", backgroundColor: "#f0fdf4", borderRadius: "8px", "&:hover": { backgroundColor: "#dcfce7" } }}
                                                                onClick={() => {
                                                                    const apiBase = process.env.REACT_APP_API_URL;
                                                                    const url = `${apiBase}/download${nota.caminhoPDF}`;
                                                                    window.open(url, '_blank');
                                                                }}
                                                            >
                                                                <CloudDownloadOutlinedIcon sx={{ fontSize: 18 }} />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title={podeCancelar ? "Cancelar Nota Fiscal" : "Esta nota não pode ser cancelada"}>
                                                            <span>
                                                                <IconButton
                                                                    size="small"
                                                                    disabled={!podeCancelar}
                                                                    sx={{ color: "#dc2626", backgroundColor: "#fef2f2", borderRadius: "8px", "&:hover": { backgroundColor: "#fee2e2" }, "&.Mui-disabled": { backgroundColor: "#f9fafb" } }}
                                                                    onClick={() => {
                                                                        handleCancelNota(nota.idIntegracao);
                                                                    }}
                                                                >
                                                                    <CancelOutlinedIcon sx={{ fontSize: 18 }} />
                                                                </IconButton>
                                                            </span>
                                                        </Tooltip>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={5} align="center" sx={{ borderBottom: "none", py: 6 }}>
                                            <ReceiptLongOutlinedIcon sx={{ fontSize: 36, color: "#d1d5db" }} />
                                            <Typography sx={{ mt: 1, fontSize: 14, fontWeight: 600, color: "#374151" }}>
                                                Nenhuma nota fiscal encontrada.
                                            </Typography>
                                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                                {notasFiscais.length > 0 ? "Tente ajustar a busca ou o filtro de status." : "Quando você emitir uma NFS-e, ela aparecerá aqui."}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 1 }}>
                        <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                            Exibindo <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{notasFiltradas.length}</Box> de {notasFiscais.length} notas
                        </Typography>
                        <Button
                            size="small"
                            startIcon={<AddCircleOutlineIcon sx={{ fontSize: "16px !important" }} />}
                            onClick={() => navigate("../Dashboard/EmitirNotaServico")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 700, color: "#111827", "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Emitir nova nota fiscal
                        </Button>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
            <Loading open={open} />
        </>
    );
};

export default NotasFiscaisEmitidas;
